export const Store = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>store-icon</title>
    <g clipPath="url(#clip0_2505_1238)">
      <path
        d="M11.04 13.1067H20.9734V14.3867C20.9734 16.5067 18.7467 18.2267 16.0134 18.2267C13.2667 18.2267 11.0534 16.5067 11.0534 14.3867V13.1067H11.04Z"
        stroke="url(#paint0_linear_2505_1238)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8933 13.1067V14.3867C30.8933 16.5067 28.6667 18.2267 25.9333 18.2267C23.1867 18.2267 20.9733 16.5067 20.9733 14.3867V13.1067"
        stroke="url(#paint1_linear_2505_1238)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.04 13.1067V14.3867C11.04 16.5067 8.81333 18.2267 6.07999 18.2267C3.33333 18.2267 1.12 16.5067 1.12 14.3867V13.1067"
        stroke="url(#paint2_linear_2505_1238)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.96002 7.23999H28.0534L30.9067 13.1067H1.10669L3.96002 7.23999Z"
        stroke="url(#paint3_linear_2505_1238)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1067 7.23999L20.96 13.1067"
        stroke="url(#paint4_linear_2505_1238)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8934 7.23999L11.04 13.1067"
        stroke="url(#paint5_linear_2505_1238)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.96002 7.23994V1.2666H28.04V7.23994"
        stroke="url(#paint6_linear_2505_1238)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0933 30.6133V25.0666C12.0933 24.1866 12.72 23.48 13.5067 23.48H18.4933C19.28 23.48 19.9067 24.1866 19.9067 25.0666V30.6133"
        stroke="url(#paint7_linear_2505_1238)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.04 18.2266V30.6666H3.96002V18.2266"
        stroke="url(#paint8_linear_2505_1238)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2505_1238"
        x1="11.04"
        y1="13.1067"
        x2="15.2102"
        y2="21.1972"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#311C77" />
        <stop offset="1" stopColor="#FF2DFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2505_1238"
        x1="20.9733"
        y1="13.1067"
        x2="25.1467"
        y2="21.1927"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#311C77" />
        <stop offset="1" stopColor="#FF2DFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2505_1238"
        x1="1.12"
        y1="13.1067"
        x2="5.29341"
        y2="21.1927"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#311C77" />
        <stop offset="1" stopColor="#FF2DFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2505_1238"
        x1="1.10669"
        y1="7.23999"
        x2="3.33042"
        y2="18.5355"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#311C77" />
        <stop offset="1" stopColor="#FF2DFF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2505_1238"
        x1="20.1067"
        y1="7.23999"
        x2="21.778"
        y2="7.48309"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#311C77" />
        <stop offset="1" stopColor="#FF2DFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2505_1238"
        x1="11.04"
        y1="7.23999"
        x2="12.7113"
        y2="7.48309"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#311C77" />
        <stop offset="1" stopColor="#FF2DFF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2505_1238"
        x1="3.96002"
        y1="1.2666"
        x2="6.75175"
        y2="12.5207"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#311C77" />
        <stop offset="1" stopColor="#FF2DFF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2505_1238"
        x1="12.0933"
        y1="23.48"
        x2="19.1972"
        y2="31.261"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#311C77" />
        <stop offset="1" stopColor="#FF2DFF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2505_1238"
        x1="3.96002"
        y1="18.2266"
        x2="14.1056"
        y2="37.8652"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#311C77" />
        <stop offset="1" stopColor="#FF2DFF" />
      </linearGradient>
      <clipPath id="clip0_2505_1238">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
